import { Card, CardContent, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { Typography } from './Typography';
import { Link } from './Link';
import { Button } from './Button';

import { PAGE_HEADER_HEIGHT } from '../layout';
import { FEEDBACK_URL } from '../constants';

const HEIGHT = 480;
const MAX_WIDTH = 984;

export const NotFoundPage = () => {
  return (
    <Card
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: `${PAGE_HEADER_HEIGHT}px`,
        height: HEIGHT,
        maxWidth: MAX_WIDTH,
        marginX: 'auto',
      }}
    >
      <CardContent>
        <Stack justifyContent='center' alignItems='center'>
          <Typography variant='h4' component='h1' paragraph>
            Page Not Found
          </Typography>
          <Typography variant='body1' gutterBottom>
            The page you are looking for might have been removed or is temporarily unavailable.
          </Typography>
          <Typography variant='body1'>
            If you repeatedly reach this page from an outside link, please{' '}
            <Link href={FEEDBACK_URL} target='_blank' underline='always'>
              contact us
            </Link>
            !
          </Typography>

          <Button
            variant='contained'
            component={RouterLink}
            to='/'
            sx={{
              mt: 3,
            }}
          >
            Go Back Home
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
